export const actionTypes = {
  GET_PRODUCTS: "GET_PRODUCTS",
  SET_PRODUCTS: "SET_PRODUCTS",
  EDIT_PRODUCTS_FORM_CHANGE: "EDIT_PRODUCTS_FORM_CHANGE",
  GET_PRODUCTS_BY_ID: "GET_PRODUCTS_BY_ID",
  SET_PRODUCTS_BY_ID: "SET_PRODUCTS_BY_ID",
  CREATE_PRODUCT: "CREATE_PRODUCT",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
  SET_UPDATED_PRODUCT: "SET_UPDATED_PRODUCT",
  GET_FILTERED_PRODUCTS: "GET_FILTERED_PRODUCTS",
  SET_FILTERED_PRODUCTS: "SET_FILTERED_PRODUCTS",
  GET_PRODUCTS_CAPSULES: "GET_PRODUCTS_CAPSULES",
  SET_PRODUCTS_CAPSULES: "SET_PRODUCTS_CAPSULES",
  GET_BRAND_OPTIONS: "GET_BRAND_OPTIONS",
  SET_BRAND_OPTIONS: "SET_BRAND_OPTIONS",
  GET_CATEGORY_OPTIONS: "GET_CATEGORY_OPTIONS",
  SET_CATEGORY_OPTIONS: "SET_CATEGORY_OPTIONS",
};

export const actions = {
  getProducts: (payload) => ({
    type: actionTypes.GET_PRODUCTS,
    payload: payload,
  }),

  setProducts: (data) => ({
    type: actionTypes.SET_PRODUCTS,
    payload: data,
  }),

  setProductsEditForm: (payload) => ({
    type: actionTypes.EDIT_PRODUCTS_FORM_CHANGE,
    payload: payload,
  }),

  getProductsById: (payload) => ({
    type: actionTypes.GET_PRODUCTS_BY_ID,
    payload: payload,
  }),

  setProductsById: (payload) => ({
    type: actionTypes.SET_PRODUCTS_BY_ID,
    payload: payload,
  }),

  createProduct: (payload) => ({
    type: actionTypes.CREATE_PRODUCT,
    payload: payload
  }),

  updateProduct: (payload) => ({
    type: actionTypes.UPDATE_PRODUCT,
    payload: payload,
  }),

  setUpdatedProduct: (payload) => ({
    type: actionTypes.SET_UPDATED_PRODUCT,
    payload: payload,
  }),

  getFilteredProducts: (payload) => ({
    type: actionTypes.GET_FILTERED_PRODUCTS,
    payload: payload,
  }),

  setFilteredProducts: (payload) => ({
    type: actionTypes.SET_FILTERED_PRODUCTS,
    payload: payload,
  }),

  getCapsuleTypes: (payload) => ({
    type: actionTypes.GET_PRODUCTS_CAPSULES,
    payload: payload,
  }),

  setCapsuleTypes: (data) => ({
    type: actionTypes.SET_PRODUCTS_CAPSULES,
    payload: data,
  }),

  getBrandOptions: (payload) => ({
    type: actionTypes.GET_BRAND_OPTIONS,
    payload: payload,
  }),

  setBrandOptions: (data) => ({
    type: actionTypes.SET_BRAND_OPTIONS,
    payload: data,
  }),

  getCategoryOptions: (payload) => ({
    type: actionTypes.GET_CATEGORY_OPTIONS,
    payload: payload,
  }),

  setCategoryOptions: (data) => ({
    type: actionTypes.SET_CATEGORY_OPTIONS,
    payload: data,
  }),
};
